import React, { useContext } from 'react';
import CompanySectionLayout from '../../../../component/B2B/CompanySectionLayout';
import { SidebarContext } from '../../../../context/SidebarContext';
import { getLocalStorageItem } from '../../../../utils/helper';

/**
 * Shell for the COMPANY panel's Habit Tracker section. Title, mode badge,
 * page dropdown and department filter all come from CompanySectionLayout,
 * shared with Sleep and Breathwork.
 */
const CompanyHabitsLayout = ({ children }) => {
  const { isB2BFansMode } = useContext(SidebarContext);
  const userData = JSON.parse(getLocalStorageItem('userData') || '{}');
  const slug = userData?.slug;

  const population = isB2BFansMode ? 'members' : 'employees';

  const pages = [
    {
      label: 'Tracker Dashboard',
      path: `/${slug}/habits`,
      description: 'Streaks, completions and habit mix'
    },
    {
      label: isB2BFansMode ? 'Members' : 'Employees',
      path: `/${slug}/habits/users`,
      description: `Per-${population.replace(/s$/, '')} habit records`
    }
  ];

  return (
    <CompanySectionLayout
      title="Habit Tracker"
      subtitle={`Which habits your ${population} keep, and how consistently.`}
      pages={pages}
    >
      {children}
    </CompanySectionLayout>
  );
};

export default CompanyHabitsLayout;
